import { useCallback } from "react";

import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MdExpandMore } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";

import { profilePath } from "@path/admin_users_paths";

import {
  getSuToken,
  removeAuthorizationToken,
  setAuthorizationCookie,
  setAuthorizationToken,
} from "@/authorization_token";
import UserAvatar from "@/containers/UserAvatar";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { SUPPORTED_LANGUAGES } from "@/i18n";
import { logout, sessionSelector } from "@/store/sessionReducer";

export default function UserProfileButton() {
  const session = useAppSelector(sessionSelector);
  const { currentUser } = session;
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation(["translation"]);
  const navigate = useNavigate();

  const logoutCb = useCallback(() => {
    removeAuthorizationToken();
    dispatch(logout());
    navigate("/login");
  }, [dispatch, navigate]);

  const unSuCb = useCallback(() => {
    const suToken = getSuToken();
    if (suToken) {
      removeAuthorizationToken();
      setAuthorizationToken(suToken);
      setAuthorizationCookie(suToken);
      document.location.href = "/";
    }
  }, []);

  return (
    <Dropdown align="end" className="TT-top-bar-user">
      <Dropdown.Toggle as="button" type="button" className="TT-top-bar-user-btn" id="TT-top-bar-user-menu">
        <UserAvatar avatar={currentUser.avatar} type="thumb" />
        <span className="TT-top-bar-user-name">{currentUser.contact?.displayName}</span>
        <MdExpandMore size={16} className="TT-top-bar-user-caret" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="TT-top-bar-user-dropdown">
        <div className="TT-top-bar-user-langs">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <button
              key={lang}
              type="button"
              className={clsx("TT-top-bar-user-lang-btn", {
                "TT-top-bar-user-lang-btn-active": i18n.language?.startsWith(lang),
              })}
              onClick={() => i18n.changeLanguage(lang)}
            >
              {t(`translation:languages.${lang}`)}
            </button>
          ))}
        </div>

        <Dropdown.Divider className="TT-top-bar-user-divider" />

        <Dropdown.Item as={Link} className="TT-top-bar-user-item" to={profilePath(session)}>
          {t("translation:header.profile")}
        </Dropdown.Item>

        {localStorage.getItem("su_token") && (
          <Dropdown.Item as="button" className="TT-top-bar-user-item TT-top-bar-user-item-btn" onClick={unSuCb}>
            {t("translation:header.unsu")}
          </Dropdown.Item>
        )}

        <Dropdown.Item as="button" className="TT-top-bar-user-item TT-top-bar-user-item-btn" onClick={logoutCb}>
          {t("translation:header.logout")}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
